import React from "react";

import {BaseProps} from "../../../../infrastructure/models/props/base-props";
import {LeftArrow} from "../../../../core/icons/arrows/left-arrow";
import {RightArrow} from "../../../../core/icons/arrows/right-arrow";
import classnames from "classnames";
import styles from "../../styles/box-scores-widget.module.scss";

class BoxScoresWidgetTableStatsForwardArrowDesktopProps extends BaseProps {
  className: String;
  isRtl: Boolean;
  onClickNext: Function;
}

export const BoxScoresWidgetTableStatsForwardArrowDesktop = (({className, isRtl, onClickNext}: BoxScoresWidgetTableStatsForwardArrowDesktopProps) => {
  const forwardContainer = {
    className: classnames(styles.table_arrow_container, styles.table_arrow_container_forward),
    onClick: () => onClickNext?.()
  }

  return (
    <div {...forwardContainer}>
      {
        isRtl ? <LeftArrow className={className}/> : <RightArrow className={className}/>
      }
    </div>
  )
});